import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
// import { Calendar } from 'primereact/calendar';
import { Dropdown } from "primereact/dropdown";
import { Card } from "primereact/card";
import { InputMask } from "primereact/inputmask";

import ModalSeplag from "../../components/ModalSeplag";
import RotuloSeplag from "../../components/RotuloSeplag";
import useSelecaoAmparoLegal, { SelecaoAmparoLegalRender } from "../../components/SelecaoAmparoLegal";

import { salvarCompensacao, listaTipoEventoCertidao } from "../../service/CertidaoCompensacao";
import { pesquisarAll as pesquisarAllEmpresa } from "../../service/empresa";

import { buscarCertidaoAtivaLegada } from "../../service/certidao";
import { ErrorOutline, CheckCircleOutline } from "@material-ui/icons";
import { classNames, isFormFieldValid, getFormErrorMessage } from "../../config/global";

import "./style.css";

const CertidaoCompensacaoForm = ({ idenCertidao, showForm, onClose, dataForm, handleSalvar }) => {
  const amparo = useSelecaoAmparoLegal({ amparos: dataForm.listaAmparoLegal });
  const [existeAutenticacaoLegada, setExisteAutenticacaoLegada] = useState(false);
  const [validaCertidaoLegada, setValidaCertidaoLegada] = useState(null);
  // const [_, setCertidao] = useState(null);
  const [listaEmpresa, setListaEmpresa] = useState([]);

  useEffect(() => {
    buscarCertidaoAtivaLegada(idenCertidao).then((res) => {
      // setCertidao(res.certidao)
      setValidaCertidaoLegada(res.validaCertidaoLegada);
    });

    pesquisarAllEmpresa().then((res) => {
      setListaEmpresa(res);
    });
  }, [idenCertidao]);

  useEffect(() => {
    if (validaCertidaoLegada && validaCertidaoLegada.dataCompensCert && validaCertidaoLegada.flagCompensacao !== "S") {
      setExisteAutenticacaoLegada(true);
    }
  }, [validaCertidaoLegada]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { ...dataForm, empresa: null },
    validade: (data) => {
      let erros = {};

      if (data.dataEventoCertidao === "") {
        erros.dataEventoCertidao = "Data é de preenchimento obrigatório";
      }

      if (!data.empresa) {
        erros.empresa = "Pessoa Jurídica é de preenchimento obrigatório";
      }

      if (!data.valorEvento || data.valorEventoAnterior === 0) {
        erros.valorEventoAnterior = "Valor do Evento Anterior é de preenchimento obrigatório";
      }

      if (!data.valorEvento || data.valorEvento === 0) {
        erros.valorEvento = "Valor do Evento Executado é de preenchimento obrigatório";
      }

      if (!data.valorEvento || data.valorEventoPos === 0) {
        erros.valorEventoPos = "Valor do Evento Posterior é de preenchimento obrigatório";
      }

      if (!data.tipoEventoCertidao.siglTipoEventoCertidao) {
        erros.tipoEventoCertidao = {
          siglTipoEventoCertidao: "Tipo de evento é de preenchimento obrigatório",
        };
        erros["tipoEventoCertidao.siglTipoEventoCertidao"] = "Tipo de evento é de preenchimento obrigatório";
      }

      return erros;
    },
    onSubmit: (data) => {
      // let dataEventoCertidao = new Date(data.dataEventoCertidao)
      let dadosBody = { ...data };

      dadosBody.listaAmparoLegalCertidao = [...amparo.justificativasSelecionada];
      dadosBody.dataEventoCertidao = data.dataEventoCertidao;

      salvarCompensacao(dadosBody).then((res) => {
        if (handleSalvar) {
          handleSalvar(res);
        }
      });
    },
  });

  const handleClose = () => {
    formik.resetForm();
    onClose();
  };

  const handleImportarAutenticacao = () => {
    formik.setFieldValue("dataEventoCertidao", validaCertidaoLegada.dataCompensCert);
    formik.setFieldValue("descComplemento", validaCertidaoLegada.numrProcessoCompensacao);
    formik.setFieldValue("valorEvento", validaCertidaoLegada.valrCompensado);
  };

  return (
    <ModalSeplag type="NONE" visible={showForm} fechar={handleClose} tamanho={"80em"} titulo="Registrar Compensação">
      <div className="p-col-12 ">
        <form onSubmit={formik.handleSubmit}>
          <div className="p-grid" style={{ paddingTop: "10px" }}>
            <div className="p-col-12 p-md-12 p-grid">
              {existeAutenticacaoLegada && (
                <div className="p-col-12" style={{ padding: "20px 10px", marginBottom: "15px" }}>
                  <Card
                    className={`
                          ${
                            validaCertidaoLegada && validaCertidaoLegada.dataCompensCert === formik.values.dataEventoCertidao && validaCertidaoLegada.valrCompensado === formik.values.valorEvento && validaCertidaoLegada.numrProcessoCompensacao === formik.values.descComplemento
                              ? "modal-card-importado"
                              : "modal-card"
                          }
                         `}
                  >
                    <div style={{ display: "flex", alignItems: "center" }} onClick={handleImportarAutenticacao}>
                      {validaCertidaoLegada && validaCertidaoLegada.dataCompensCert === formik.values.dataEventoCertidao && validaCertidaoLegada.valrCompensado === formik.values.valorEvento && validaCertidaoLegada.numrProcessoCompensacao === formik.values.descComplemento ? (
                        <CheckCircleOutline c style={{ color: "#067406", fontSize: "2.2rem", flex: "1" }} />
                      ) : (
                        <ErrorOutline style={{ color: "#e95c09", fontSize: "2.2rem", flex: "1" }} />
                      )}
                      <p className="m-0" style={{ lineHeight: "1.5", flex: "13" }}>
                        Existe informação de Data, Valor e Nº Processo de Compensação no LEGADO. Click aqui se deseja importar.
                      </p>
                    </div>
                  </Card>
                </div>
              )}

              <div className={`p-col-12 ${existeAutenticacaoLegada} p-grid`}>
                <RotuloSeplag obrigatorio nome="Data do Evento" cols="12 ">
                  <InputMask id="dataEventoCertidao" name="dataEventoCertidao" mask="99/99/9999" value={formik.values.dataEventoCertidao} placeholder="99/99/9999" slotChar="mm/dd/yyyy" onChange={(e) => formik.handleChange(e)} />
                  {getFormErrorMessage("dataEventoCertidao", formik)}
                </RotuloSeplag>

                <RotuloSeplag obrigatorio nome="Tipo Compensação" cols="12 6">
                  <Dropdown
                    name="tipoEventoCertidao.siglTipoEventoCertidao"
                    value={formik.values.tipoEventoCertidao.siglTipoEventoCertidao}
                    options={listaTipoEventoCertidao}
                    onChange={(e) => formik.handleChange(e)}
                    className={classNames({ "p-invalid": isFormFieldValid("tipoEventoCertidao.siglTipoEventoCertidao", formik) })}
                    showClear
                  />
                </RotuloSeplag>

                <RotuloSeplag obrigatorio nome="Valor Anterior" cols="12 6 2">
                  <InputNumber name="valorEventoAnterior" value={formik.values.valorEventoAnterior} onValueChange={(e) => formik.handleChange(e)} mode="decimal" minFractionDigits={2} className={classNames({ "p-invalid": isFormFieldValid("valorEventoAnterior", formik) })} />
                  {getFormErrorMessage("valorEventoAnterior", formik)}
                </RotuloSeplag>

                <RotuloSeplag obrigatorio nome="Valor Executado" cols="12 6 2">
                  <InputNumber name="valorEvento" value={formik.values.valorEvento} onValueChange={(e) => formik.handleChange(e)} mode="decimal" minFractionDigits={2} className={classNames({ "p-invalid": isFormFieldValid("valorEvento", formik) })} />
                  {getFormErrorMessage("valorEvento", formik)}
                </RotuloSeplag>

                <RotuloSeplag obrigatorio nome="Valor Pós" cols="12 6 2">
                  <InputNumber name="valorEventoPos" value={formik.values.valorEventoPos} onValueChange={(e) => formik.handleChange(e)} mode="decimal" minFractionDigits={2} className={classNames({ "p-invalid": isFormFieldValid("valorEventoPos", formik) })} />
                  {getFormErrorMessage("valorEventoPos", formik)}
                </RotuloSeplag>

                <RotuloSeplag obrigatorio nome="Pessoa Jurídica" cols="12 ">
                  <Dropdown options={listaEmpresa} name="empresa" value={formik.values.empresa} optionLabel="nomeFantasia" placeholder="Seleciona a Pessoa Jurídica" onChange={(e) => formik.handleChange(e)} />
                </RotuloSeplag>

                <RotuloSeplag obrigatorio nome="Descrição Complemento" cols="12 12">
                  <InputText name="descComplemento" value={formik.values.descComplemento} onChange={(e) => formik.handleChange(e)} />
                </RotuloSeplag>
              </div>
            </div>

            <SelecaoAmparoLegalRender {...amparo} />

            <div className="p-col-12 p-md-3">
              <Button type="submit" label="Salvar" />
            </div>
            <div className="p-col-12 p-md-3">
              <Button type="button" label="Cancelar" icon="pi pi-times" className="p-button-raised p-button-danger" onClick={handleClose} />
            </div>
          </div>
        </form>
      </div>
    </ModalSeplag>
  );
};

export default CertidaoCompensacaoForm;
